import { combineReducers } from "redux";
import recycleState from "redux-recycle"; // reset reducers to initailstate
import { localeReducer as locale } from "react-localize-redux";
import { loginReducer } from "./components/login/loginReducer";
import {
  verifyUserReducer,
  resendVerifyCodeReducer
} from "./components/verifyUser/verifyUserReducer";

import { navigationReducer } from "./components/body/Navigation";
import {
  forgotPasswordReducer,
  verifyForgotPasswordCodeReducer,
  changePasswordReducer,
  resendForgotPasswordCodeReducer
} from "./components/forgotPassword/forgotPasswordReducer";
import { dashboardReducer } from "./components/Dashboard/dashboardReducer";
import { patientReferralReducer } from "./components/PatientReferrals/PatientReferralReducer";

const appReducer = combineReducers({
  navigation: navigationReducer,
  login: recycleState(loginReducer, ["RESET_REDUCERS"], {}),
  dashboard: dashboardReducer,
  verifyUser: verifyUserReducer,
  resendVerifyCode: resendVerifyCodeReducer,
  forgotPassword: forgotPasswordReducer,
  verifyForgotPasswordCode: verifyForgotPasswordCodeReducer,
  changePassword: changePasswordReducer,
  resendForgotPasswordCode: resendForgotPasswordCodeReducer,
  patientReferrals: patientReferralReducer,
  locale
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_REDUCERS") {
    let langInfo = state.locale;
    state = undefined;
    state = { locale: langInfo }; // Save language details
  }

  return appReducer(state, action);
};

export default rootReducer;
